import React, {useEffect, useState, useCallback} from 'react';
import {API} from "aws-amplify";
import MaterialTable from "material-table";
import {PROFESSORS_SIMULATION_COLUMN_DEFINITION} from "../../Material-TableCustomization/ColumnsDefinition/ProfessorsSimulationColumnDefinition";
import {REMOVE_DROP_SHADOW} from "../../Material-TableCustomization/CSSChanges/RemoveDropShadow";
import {ICONS_OVERRIDE_SECONDARY_COLOR} from "../../Material-TableCustomization/IconsOverride/IconsOverrideSecondaryColor";
import {LOCALIZATION} from "../../Material-TableCustomization/Localization/LocalizationES";

export default function ProfessorSubjectsTable({professorId, history}) {
    const [topics, setTopics] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadTopicsApi = (professorId) => {
        return API.get('misServiciosEscolares', `/topics?professorId=${professorId}`);
    };

    const loadTopics = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await loadTopicsApi(professorId);
            setTopics(response);
        } catch (e) {
            alert('No se pudo encontrar la información deseada. Por favor intente de nuevo.');
        } finally {
            setIsLoading(false);
        }
    }, [professorId])

    useEffect(() => {
        console.log(professorId, 'professorId');
        loadTopics();
    }, [professorId, history, loadTopics]);

    return (
        <div className="Professors">
            <MaterialTable
                columns={PROFESSORS_SIMULATION_COLUMN_DEFINITION(history)}
                data={topics}
                isLoading={isLoading}
                title="Materias Asignadas"
                components={REMOVE_DROP_SHADOW}
                icons={ICONS_OVERRIDE_SECONDARY_COLOR}
                localization={LOCALIZATION('materia', 'materias')}
                options={{
                    search: true,
                    pageSize: 20,
                    filtering: true,
                }}
            />
        </div>
    );
};